import { PortalBgType, PortalClassStateOrMedia, ThemeColorSchemas } from '@nx-frontend/shared/types';
import { getClassNamePrefix, getColorSchemaPrefix } from './getTheme';

export function getFillClassNames(
  themeColors: ThemeColorSchemas,
  type: PortalBgType = PortalBgType.PRIMARY,
  states: PortalClassStateOrMedia[] = []
): string[] {
  const state = getClassNamePrefix(states);

  return themeColors.reduce<string[]>((classNames, { schema, colors }) => {
    const {
      [type]: [color],
    } = colors;

    const prefix = getColorSchemaPrefix(schema) + state;
    classNames.push(`${prefix}fill-${color}`);
    return classNames;
  }, []);
}
